import useTranslate from "hooks/useTranslate";
import { Swiper, SwiperSlide } from "swiper/react";
import { LoyaltyRewardHelp } from "components/molecules/LoyaltyRewardHelp";
import { LoyaltyMoreRewardCard } from "components/molecules/LoyaltyMoreRewardCard";
import { LOYALTY_MORE_REWARD_CARD_LIST } from "constants/loyalty";
import url from "../../../url";
import "./styles.sass";
import { useBreakpoint } from "../../../hooks/useBreakpoint";

export const LoyaltyMoreRewards = () => {
  const t = useTranslate();
  const redirectUrl = url.routes.profile.bonus();
  const { isPhone } = useBreakpoint();

  const content = isPhone ? (
    <div className="LoyaltyMoreRewards__cards">
      <Swiper
        spaceBetween={16}
        slidesPerView="auto"
        freeMode
        init={false}
        grabCursor
      >
        {LOYALTY_MORE_REWARD_CARD_LIST.map((card) => {
          return (
            <SwiperSlide key={card.id} className="LoyaltyMoreRewards__card">
              <LoyaltyMoreRewardCard key={card.id} card={card} />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  ) : (
    <div className="LoyaltyMoreRewards__cardsGrid">
      {LOYALTY_MORE_REWARD_CARD_LIST.map((card) => {
        return <LoyaltyMoreRewardCard key={card.id} card={card} />;
      })}
    </div>
  );

  return (
    <div className="LoyaltyMoreRewards">
      <h2 className="LoyaltyMoreRewards__header">
        {t("loyalty.more.reward.title")}
      </h2>
      <span className="LoyaltyMoreRewards__desc">
        {t("loyalty.more.reward.desc")}
      </span>
      {content}
      <LoyaltyRewardHelp
        text="loyalty.more.reward.help"
        bntText="loyalty.btn.myBonuses"
        background="var(--primary)"
        redirectUrl={redirectUrl}
      />
    </div>
  );
};
